/*
 * Copyright (c) 2008-2020 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */
import { log } from "~/common/src/utils/log"
import communication from "~/common/src/messaging" // or simply 'messaging' (but this is not detected by IDEA)
import Vue from "vue"
import hash from "object-hash"

export default {
  namespaced: true,

  state: {
    // maps hashes of RqlKeys to objects of type {key: rqlKey, value: result}
    results: {},
  },

  mutations: {
    /**
     * Stores the specified result for the specified RqlKey.
     * (Called by message handler for incoming ResultMessages)
     *
     * @param state
     * @param rqlKey The RqlKey to store the result for ({template: "rqlName", parameters:{}})
     * @param result The result to store
     */
    resultReceived(state, { rqlKey, result }) {
      log.info("Writing new result to store for RqlKey ", rqlKey)
      let keyHash = hash(rqlKey)
      Vue.set(state.results, keyHash, { key: rqlKey, value: result })
    },
  },

  actions: {
    /**
     * Subscribes/ un-subscribes for receiving updates on the specified RqlKey.
     * (Client will be unsubscribed from all subscription scopes not contained in the passed subscriptionScopes array.)
     *
     * @param commit
     * @param state
     * @param rqlKey The RqlKey to subscribe for ({template: "rqlName", parameters:{}})
     * @param subscriptionScopes The scopes to subscribe with [NOTIFICATION, QUERY_RESULT]
     */
    subscribeForRql({ commit, state }, { rqlKey, subscriptionScopes }) {
      log.info("Adding or updating subscription for rql ", rqlKey, " with subscription scopes ", subscriptionScopes)
      communication.sendMessage({
        messageType: "RqlSubscriptionMessage",
        rqlKey: rqlKey,
        subscriptionScopes: subscriptionScopes,
      })
    },
  },

  getters: {
    /**
     * Returns the result currently stored for the specified RqlKey or null if no result is available.
     *
     * @param state
     * @param rqlKey The RqlKey to return a result for ({template: "rqlName", parameters:{}})
     */
    result: state => rqlKey => {
      let keyHash = hash(rqlKey)
      let entry = state.results[keyHash]
      return entry !== undefined && entry.hasOwnProperty("value") ? entry.value : null
    },
  },
}
